import React from 'react';

class Buttons extends React.Component {
  render() {
    return (
      <div className="walkthrough-buttons">
        <a
          href="#"
          onClick={this.props.back}
          className="cpt-button style-subtle back-button"
          style={{ display: !this.props.backText ? 'none' : null }}
        >
          {this.props.backText}
        </a>
        <a
          href="#"
          onClick={this.props.continue}
          className="cpt-button style-primary"
          style={{ display: !this.props.continueText ? 'none' : null }}
        >
          {this.props.continueText}
        </a>
      </div>
    );
  }
}

export default Buttons;
